function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.01852 8.16671C3.73215 8.16671 3.5 7.64437 3.5 7.00004C3.5 6.35571 3.73215 5.83337 4.01852 5.83337H12.3148C12.6012 5.83337 12.8333 6.35571 12.8333 7.00004C12.8333 7.64437 12.6012 8.16671 12.3148 8.16671H4.01852ZM4.66667 15.1667C4.02233 15.1667 3.5 14.6444 3.5 14C3.5 13.3557 4.02233 12.8334 4.66667 12.8334H23.3333C23.9777 12.8334 24.5 13.3557 24.5 14C24.5 14.6444 23.9777 15.1667 23.3333 15.1667H4.66667ZM15 20.9999C15 21.5522 15.2239 21.9999 15.5 21.9999H23.5C23.7761 21.9999 24 21.5522 24 20.9999C24 20.4476 23.7761 19.9999 23.5 19.9999H15.5C15.2239 19.9999 15 20.4476 15 20.9999Z",
  fill: "#222B45"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 5,
  width: 22,
  height: 17
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.01852 8.16671C3.73215 8.16671 3.5 7.64437 3.5 7.00004C3.5 6.35571 3.73215 5.83337 4.01852 5.83337H12.3148C12.6012 5.83337 12.8333 6.35571 12.8333 7.00004C12.8333 7.64437 12.6012 8.16671 12.3148 8.16671H4.01852ZM4.66667 15.1667C4.02233 15.1667 3.5 14.6444 3.5 14C3.5 13.3557 4.02233 12.8334 4.66667 12.8334H23.3333C23.9777 12.8334 24.5 13.3557 24.5 14C24.5 14.6444 23.9777 15.1667 23.3333 15.1667H4.66667ZM15 20.9999C15 21.5522 15.2239 21.9999 15.5 21.9999H23.5C23.7761 21.9999 24 21.5522 24 20.9999C24 20.4476 23.7761 19.9999 23.5 19.9999H15.5C15.2239 19.9999 15 20.4476 15 20.9999Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.3575e99c7f55e0ceb644450a9652b6a4.svg";
export { ForwardRef as ReactComponent };